import React from 'react'
import PropTypes from 'prop-types'
import styles from './ResultEmphasis.module.css'

class ResultEmphasis extends React.Component {
  static propTypes = {
    outcome: PropTypes.string
  }
  static defaultProps = {
    outcome: ''
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // Get all elements, save them as numbers
    // Separate outcome to floatNumber and/or symbol
    const outcome = this.props.outcome
    this.number = parseFloat(outcome)
    this.symbol = outcome.match(new RegExp(/[^0-9,.]/g)) // Match all non-numeric and non-comma/dot characters
  }

  render() {
    return (
      <div
        className={`${styles.root} result-emphasis`}
        data-targetnumber={this.number}
        data-symbol={this.symbol && this.symbol.join('')}
      >
        0 {this.symbol}
      </div>
    )
  }
}

export default ResultEmphasis
